import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'umi';
import type { INumericalValueItem, INumericalValueRule } from '../../type';
import NumericalValuesGroupRows from './NumericalValuesGroupRows';
import './index.scss';

export interface INumericalValuesGridProps {
  groups: INumericalValueItem[];
  onAddRule: (groupId: string) => void;
  onDeleteRule: (groupId: string, ruleIndex: number) => void;
  onRuleChange: (
    groupId: string,
    ruleIndex: number,
    rule: INumericalValueRule,
  ) => void;
}

const NumericalValuesGrid: React.FC<INumericalValuesGridProps> = ({
  groups,
  onAddRule,
  onDeleteRule,
  onRuleChange,
}) => {
  const { formatMessage } = useIntl();
  const isEmpty = groups.length === 0;
  const emptyText = formatMessage({
    id: 'dbl_table_condition_select_metrics_placeholder',
  });
  const metricsHeader = formatMessage({ id: 'dbl_table_condition_merrics' });
  const ruleHeader = formatMessage({ id: 'dbl_table_condition_rule' });
  const colorHeader = formatMessage({ id: 'dbl_table_condition_color' });
  const iconHeader = formatMessage({ id: 'dbl_table_condition_icon' });
  const actionHeader = formatMessage({ id: 'dbl_common_operation' });

  return (
    <div className="dbl-numerical-values-grid dbl-hover-scrollbar-area">
      <div className="dbl-numerical-values-grid__header">
        <div className="dbl-numerical-values-grid__header-indicator">
          {metricsHeader}
        </div>
        <div className="dbl-numerical-values-grid__header-content">
          <div className="dbl-numerical-values-grid__header-col">
            {ruleHeader}
          </div>
          <div className="dbl-numerical-values-grid__header-col">
            {colorHeader}
          </div>
          <div className="dbl-numerical-values-grid__header-col">
            {iconHeader}
          </div>
          <div className="dbl-numerical-values-grid__header-col">
            {actionHeader}
          </div>
        </div>
      </div>

      <div
        className={classNames(
          'dbl-numerical-values-grid__body',
          'dbl-hover-scrollbar',
          {
            'dbl-numerical-values-grid__body--empty': isEmpty,
          },
        )}
      >
        {isEmpty ? (
          <div className="dbl-numerical-values-grid__empty">{emptyText}</div>
        ) : (
          groups.map(group => {
            const rules = group.rules || [];

            return (
              <div key={group.id} className="dbl-numerical-values-grid__group">
                <div className="dbl-numerical-values-grid__indicator">
                  {group.name || group.metric || '-'}
                </div>

                <NumericalValuesGroupRows
                  groupId={group.id}
                  rules={rules}
                  onAddRule={onAddRule}
                  onDeleteRule={onDeleteRule}
                  onRuleChange={onRuleChange}
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default NumericalValuesGrid;
